export const generateCookieParams = (env, currentNetwork) => {
  const {
    network_configuration: {
      payment_gateway: paymentMethod = null,
      has_payment_account: hasPaymentAccount = false,
      linked_in_is_enabled: linkedInIsEnabled = false,
      twitter_is_enabled: twitterIsEnabled = false,
      facebook_is_enabled: facebookIsEnabled = false,
      has_google_analytics_tracking: hasGoogleAnalyticsTracking = false,
    } = {},
    features: {
      amplitude: {
        config: { amplitude_enabled: amplitudeIsEnabled } = {},
      } = {},
      cookies: { config: { cookies: customCookies } = {} } = {},
    } = {},
  } = currentNetwork || {};

  return {
    env,
    paymentMethod,
    hasPaymentAccount,
    amplitudeIsEnabled,
    linkedInIsEnabled,
    customCookies,
    twitterIsEnabled,
    facebookIsEnabled,
    hasGoogleAnalyticsTracking,
  };
};
